import { Component, EventEmitter, Output } from '@angular/core';
import { DisputesService } from '../dispute.service';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-dispute-modal',
  standalone: true,
  templateUrl: './dispute-modal.component.html',
  styleUrl: './dispute-modal.component.scss',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, RouterModule],
})
export class DisputeModalComponent {
  extra_data!: extra_data;
  modalType: string = '';
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() docData: EventEmitter<any> = new EventEmitter();
  isUploading = false;
  uploadProgress = 0;
  uploadError: boolean = false;
  uploadedFile: File | null = null;
  new_doc_name = '';
  selectedShape = 'rectangle';
  croppedImage: any;
  public submittionForm!: UntypedFormGroup;
  pending_doc:any

  constructor(
    public _dispute: DisputesService,
    private fb: UntypedFormBuilder,
    public bsModalRef: BsModalRef,
    public _shared:SharedService
  ){}
  ngOnInit() {
    if (this._dispute.modalTypes.submittion == this.modalType) {      
      this.submittionForm = this.fb.group({
      });
    }
    if (this.extra_data.total_doc_count && this.extra_data.doc_count) {
      this.pending_doc = this.extra_data.total_doc_count - this.extra_data.doc_count
    } 
  }
  
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    
    if (file && (file.size > (10 * 1024 * 1024))) {
      this._shared.customPopups('File size is too large, you can upload maximum 10MB file.', 1);
      event.target.value = '';
      return;
    };

    if (file && (file.type != "image/png" && file.type != 'application/pdf' && file.type != 'image/jpeg' && file.type != 'image/jpg')) {
      this._shared.customPopups('File type not supported. Please upload a valid file(.pdf, .jpg, .jpeg, .png).', 1);
      event.target.value = '';
      return;
    }
   
    this.uploadError = true;
    if (file) {
      this.uploadedFile = file;
      this.isUploading = true;
      this.uploadProgress = 0;
      const uploadInterval = setInterval(() => {
        if (this.uploadProgress < 100) {
          this.uploadProgress += 10;
        } else {
          clearInterval(uploadInterval);
          this.isUploading = false;
          this.uploadProgress = 100;
        }
      }, 300);
    }
  }

  uploadFile() {
    if (this.extra_data.showInput && this.new_doc_name.trim() == "") {
      this._shared.customPopups('File name is required', 1);
      return
    }
    // if (this.new_doc_name.trim() == "") {
    //   return this._shared.customPopups("please enter a valid file name", 1);
    // }
    if (this.uploadedFile && this.uploadProgress === 100) {
      this.docData.emit({ uploadedFile: this.uploadedFile, new_doc_name: this.new_doc_name.trim() });
      // this.modalHide()
      this.bsModalRef.hide();
    }
  }
  
  confirm() {
    this.docData.emit({ delete: true });
    this.modalHide()
  }

  removeFile() {
    this.uploadedFile = null;
    this.uploadProgress = 0;
    this.uploadError = false;
    const fileInput = document.querySelector('#fileInput') as HTMLInputElement;
    console.log(fileInput.value);
    
    if (fileInput) {
      fileInput.value = '';
    }
    console.log(fileInput.value);
    
  }

  modalHide() {
    this.passEntry.emit({ success: true });
    this.bsModalRef.hide();
  }
}

interface extra_data {
  doc_count?: number;
  showInput?:boolean;
  contract?: any;
  fromPage?: string;
  label?: string,
  imageChangedEvent?:any,
  total_doc_count?:number
}

